function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Type from "./type";
import Action from "../action";
var loading = false;
var dirtyPrompt = "Changes you made have not been saved. Are you sure?";

var HttpRequest = /*#__PURE__*/function () {
  function HttpRequest() {
    _classCallCheck(this, HttpRequest);

    this.controller = new AbortController();
    this.canceled = false;
  }

  _createClass(HttpRequest, [{
    key: "cancel",
    value: function cancel() {
      this.canceled = true;
      this.controller.abort();
    }
  }]);

  return HttpRequest;
}();

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "_extractFormData",
    value: function _extractFormData(properties, needCsrfToken) {
      // if (properties["formDataEncoded"]) {
      //   return properties["formData"];
      // }
      var data = properties.formData;

      if (data instanceof FormData) {
        return data;
      }

      var formData = new FormData();
      var params = data || {};

      for (var key in params) {
        formData.append(key, params[key]);
      }

      if (needCsrfToken && !Type.isString(params["authenticity_token"])) {
        formData.append("authenticity_token", Utils.dom.getCsrf());
      }

      return formData;
    }
  }, {
    key: "load",
    value: function load(properties, component) {
      var _this = this;

      var url = new URL(properties["url"]);
      var domainMatched = window.location.hostname == url.hostname; // If this is an external domain, we rely on `onUnload()` instead.

      if (domainMatched && !this.proceedEvenWhenDirty()) {
        return;
      }

      if (Utils.settings.reactive && domainMatched) {
        var currentUrl = window.location.href;
        var htmlUrl = Utils.url.htmlUrl(properties["url"]);
        Utils.http.execute(properties, "GET", component, function (data, response) {
          if (htmlUrl !== currentUrl) {
            var redirectUrl = Utils.url.htmlUrl(response.url);
            Utils.history.pushPage(data, redirectUrl);
          }

          _this.forceComponentUpdate(function () {
            Utils.history.resetScroll();
            window.vueApp.page = data;
            Action.execute(properties["onOpen"], component);
          });
        });
      } else {
        window.location = Utils.url.htmlUrl(properties["url"]);
      } // bus.$emit("glibWebHttpLoad", new URL(Utils.url.htmlUrl(properties["url"])));

    }
  }, {
    key: "analyticsHeaders",
    value: function analyticsHeaders(component) {
      var pageAnalytics = window.vueApp.temp.analytics || window.vueApp.page.analytics || {};
      var featureAnalytics = pageAnalytics.feature;
      var headers = {};

      if (featureAnalytics && component.spec) {
        var componentAnalytics = component.spec.analytics || {};

        if (componentAnalytics.disabled) {
          return headers;
        }

        Utils.type.ifString(componentAnalytics.group || featureAnalytics.group, function (value) {
          return headers["GApp-Analytics-Referer-Group"] = value;
        });
        Utils.type.ifString(componentAnalytics.action || featureAnalytics.action, function (value) {
          return headers["GApp-Analytics-Referer-Action"] = value;
        });
        Utils.type.ifString(componentAnalytics.segment || featureAnalytics.segment, function (value) {
          return headers["GApp-Analytics-Referer-Segment"] = value;
        });
        Utils.type.ifString(componentAnalytics.placement, function (value) {
          return headers["GApp-Analytics-Referer-Placement"] = value;
        });
      }

      return headers;
    }
  }, {
    key: "reload",
    value: function reload(properties, component) {
      var currentUrl = window.location.href;
      var data = {
        url: properties.url || currentUrl
      };
      Utils.http.execute(data, "GET", component, function (page, response) {
        Utils.http.forceComponentUpdate(function () {
          window.vueApp.page = page;
          var redirectUrl = Utils.url.htmlUrl(response.url);
          Utils.history.updatePage(redirectUrl);
          GLib.action.execute(properties["onReload"], component);
        });
      });
    }
  }, {
    key: "execute",
    value: function execute(properties, methodName, component, jsonHandler) {
      this.startIndicator(component); // `fetch()` only supports uppercase

      var method = methodName.toUpperCase();
      var url = Utils.url.jsonUrl(properties["url"]);

      var body = this._extractFormData(properties, method !== "GET");

      if (method === "GET") {
        url = Utils.url.appendParams(url, body);
        body = null;
      }

      console.log("".concat(method, " ").concat(url));
      var request = new HttpRequest();
      var response = null;
      var vm = this;
      var analyticsHeaders = this.analyticsHeaders(component);
      fetch(url, {
        method: method,
        body: body,
        headers: Object.assign({
          Accept: "text/html"
        }, analyticsHeaders),
        // Make sure to pass cookies for same origin URLs.
        // Needed for some browsers, e.g. Edge and Android's native.
        credentials: "same-origin",
        signal: request.controller.signal
      }).then(function (res) {
        vm.stopIndicator(component);

        if (res.status >= 500) {
          throw "Server error";
        } else if (res.status >= 400) {
          throw "Not accessible";
        } else {
          response = res;
          return res.json();
        }
      }).then(function (data) {
        console.debug("Success", data);
        jsonHandler(data, response);
      })["catch"](function (error) {
        vm.stopIndicator(component);

        if (!request.canceled) {
          console.error("Error:", error);
          Utils.launch.snackbar.error(error, component);
        } else {
          console.info("Canceled");
        }
      });
      return request;
    }
  }, {
    key: "startIndicator",
    value: function startIndicator(component) {
      this._showIndicator();

      component.$data._isBusy = true;
    }
  }, {
    key: "stopIndicator",
    value: function stopIndicator(component) {
      this._hideIndicator();

      component.$data._isBusy = false;
    }
  }, {
    key: "_showIndicator",
    value: function _showIndicator() {
      loading = true;
      setTimeout(function () {
        if (loading) {
          loading = false;
          window.vueApp.indicator = true;
        }
      }, 200);
    }
  }, {
    key: "_hideIndicator",
    value: function _hideIndicator() {
      loading = false;
      window.vueApp.indicator = false;
    } // See generic.js

  }, {
    key: "forceComponentUpdate",
    value: function forceComponentUpdate(handler) {
      var dirtyContext = this.dirtyContext();
      window.vueApp.isStale = true; // Queue the execution so the first isStale has time to resets state before handler gets executed

      setTimeout(function () {
        dirtyContext.isFormSubmitted = false;
        dirtyContext.isFormDirty = false;
        handler();
        window.vueApp.isStale = false;
      }, 0);
    }
  }, {
    key: "promptIfDirtyOnUnload",
    value: function promptIfDirtyOnUnload() {
      var _this2 = this;

      window.onbeforeunload = function () {
        return _this2.dirtyContext().isFormDirty ? dirtyPrompt : null;
      };
    }
  }, {
    key: "dirtyContext",
    value: function dirtyContext() {
      return Utils.launch.dialog.topDialog() || window.vueApp;
    }
  }, {
    key: "clearDirtyState",
    value: function clearDirtyState() {
      this.dirtyContext().isFormDirty = false;
    }
  }, {
    key: "notifyFormSubmitted",
    value: function notifyFormSubmitted() {
      this.dirtyContext().isFormSubmitted = true;
    } // `context` can be either window or dialog.

  }, {
    key: "proceedEvenWhenDirty",
    value: function proceedEvenWhenDirty() {
      var dirtyContext = this.dirtyContext(); // Don't prompt if this is a result of form submission

      if (dirtyContext.isFormDirty && !dirtyContext.isFormSubmitted && !confirm(dirtyPrompt)) {
        return false;
      }

      return true;
    }
  }]);

  return _default;
}();

export { _default as default };